import Link from 'next/link'
import pluralize from 'pluralize'

import { ButtonRebrand } from 'src/components/atoms/ButtonRebrand'
import { Image } from 'src/components/atoms/Image'
import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'

import { donatePath } from 'src/config/paths'

export enum ExampleType {
  Flight = 'flight',
  Driving = 'driving',
  Utilities = 'utilities',
  Household = 'household'
}

export interface ExampleCardRebrandProps {
  title: string
  numTrees: number
  type: ExampleType
}

const ICON: Record<ExampleType, string> = {
  [ExampleType.Flight]: '/img/icons/scenario-flights.svg',
  [ExampleType.Driving]: '/img/icons/scenario-driving.svg',
  [ExampleType.Utilities]: '/img/icons/scenario-utilities.svg',
  [ExampleType.Household]: '/img/icons/scenario-household.svg'
}

export const ExampleCardRebrand = ({
  title,
  numTrees,
  type
}: ExampleCardRebrandProps) => (
  <div className='flex h-full flex-col justify-between gap-6 bg-white p-6 text-center'>
    <div className='flex flex-col items-center gap-4'>
      <Image src={ICON[type]} height={96} width={96} alt='' />
      <TypographyRebrand variant='body' color='forestDeep'>
        {title}
      </TypographyRebrand>
    </div>
    <div className='flex flex-col items-center gap-4'>
      <h4 className='font-body-rebrand text-[20px] md:text-[32px] font-extrabold leading-[120%] mt-0 mb-0 text-forestDeep'>
        {numTrees} native {pluralize('tree', numTrees)}
      </h4>
      <Link href={donatePath({ queryParams: { quantity: numTrees } })}>
        <ButtonRebrand variant='lime'>Donate now</ButtonRebrand>
      </Link>
    </div>
  </div>
)
